import React from "react";
function AuthField({ id, label, required = false, action, error, children }) {
  return (
    <div className="auth-field">
      <div className="auth-field__label-row">
        <label htmlFor={id}>
          {label}
          {required && <span aria-hidden="true"> *</span>}
        </label>
        {action}
      </div>
      {children}
      {error && (
        <span className="auth-field__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
export default AuthField;
